module.exports = __webpack_public_path__ + "img/banner3.0a63363b.jpg";